import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ProfilerSection from './ProfilerSection';
import { showAlertHtml } from '../../common/utils/alert';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
export class ProfilerTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getProfilerData({ projectId, version });
  }

  handleToggleProfiler = () => {
    const { appSetting, match, actions } = this.props;
    const { projectId, version } = match.params;
    const { projectDetail } = appSetting;
    let toggleProfiling = projectDetail.enableProfiling;
    const preConfirm = () => {
      actions.toggleProfiler({ projectId, version, data: {} });
    };
    showAlertHtml(
      toggleProfiling
        ? `Disable Profiling?<br/><br/><span>Profiling will be stopped once you'll publish the project for the respective environment.</span>`
        : `Enable Profiling?<br/><br/><span>Please publish the project in the environment where you want to start profiling.</span>`,
      preConfirm,
      toggleProfiling ? 'Yes, disable it!' : 'Yes, enable it!',
      toggleProfiling ? 'warning' : 'info',
    );
  };

  render() {
    const { match, appSetting, actions } = this.props;
    const { projectId, version } = match.params;
    const { profilersList, getProfilerDataPending, projectDetail } = appSetting;
    if (!profilersList) return '';
    const enableProfiling = (projectDetail && projectDetail.enableProfiling) || false;

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'profiler'} projectDetail={projectDetail} />
        <ProfilerSection
          enableProfiling={enableProfiling}
          handleToggleProfiler={this.handleToggleProfiler}
          projectId={projectId}
          actions={actions}
          version={version}
          profilersList={profilersList}
          getProfilerDataPending={getProfilerDataPending}
          projectDetail={projectDetail}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilerTab);
